// The onboarding endpoints answer with { success, message, data: [...] }, but
// useAxios has already unwrapped one level (it returns response.data), so the
// rows sit at `res.data`. Older panel endpoints hand back the array directly —
// both shapes are accepted rather than assumed.
export const toRows = (res) => {
    const payload = res?.data ?? res;
    if (Array.isArray(payload)) return payload;
    return payload?.data || payload?.items || payload?.results || [];
};

export const toRecord = (res) => {
    const payload = res?.data ?? res;
    return Array.isArray(payload) ? payload[0] : payload;
};
